import { Module } from "wrapper6";

var $ = jQuery;

export default class DownloadVideo extends Module {

	ready(app) {
        
        this.OPEN_BUTTONS = document.querySelectorAll('.open-video-form-modal');
        this.TITLE_INPUT = document.getElementById('video-title');
        if (this.OPEN_BUTTONS.length == 0 && !this.TITLE_INPUT) return;

        this.video = {
            title: '',
            url: ''
        }
        
        this.eventListeners();

    }

    eventListeners() {

        // click on buttons
        this.OPEN_BUTTONS.forEach(BUTTON => {
            BUTTON.addEventListener('click', () => {
                event.preventDefault();

                // update video info
                this.video.title = BUTTON.getAttribute('data-title');
                this.video.url = BUTTON.getAttribute('href');

                // insert title in input
                this.TITLE_INPUT.value = this.video.title;

            });
        });

        // mail sent
        document.addEventListener( 'wpcf7mailsent', (event) => {
            if (event.detail.contactFormId  == 2211) {
                this.downloadVideo();
            }
        }, false );
    }

    downloadVideo() {
        let el = document.createElement('a');
        el.style.display = 'none';
        el.setAttribute('href', this.video.url);
        el.setAttribute('download', '');
        document.body.appendChild(el);
        el.click();
        el.remove();
    }
}